var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('profile-avatar-form',{scopedSlots:_vm._u([{key:"default",fn:function(i){return [_c('profile-avatar-img',{attrs:{"loading":i.loading}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }